import type { MaybeRef } from 'vue';

export const projectKeys = {
  all: ['project'] as const,
  projects: () => [...projectKeys.all, 'projects'] as const,
  project: (uuid?: MaybeRef<string>) => [...projectKeys.all, 'project', uuid ?? 'default'] as const,
  projectResources: (uuid: MaybeRef<string>) =>
    [...projectKeys.all, 'project-resources', uuid] as const,
};
